module.exports = __webpack_public_path__ + "imgs/ad1@2x.533ae239.webp";